import React, {useEffect, useState} from 'react';
import {EditLargeIcon, LoadingIcon} from "../../assets/icons/Icons";
import FormSection from "../form/Section";
import FormHeader from "../form/Header";
import Popup from "../Popup";
import { UpdateOffice } from "../../api/offices/UpdateOffice";
import CountrySelect from "../form/CountrySelect";
import StateSelect from "../form/StateSelect";
import Switch from "../form/Switch";
import useForm from "../../hooks/useForm";
import {useTranslation} from "react-i18next";

const EditOffice = ({office, onUpdate, onClose, ...props}) => {

    const { t } = useTranslation();

    const [name, setName] = useState(office.name);
    const [address1, setAddress1] = useState(office.address1);
    const [address2, setAddress2] = useState(office.address2);
    const [city, setCity] = useState(office.city);
    const [state, setState] = useState(office.state);
    const [postalCode, setPostalCode] = useState(office.postal_code);
    const [country, setCountry] = useState(office.country);
    const [status, setStatus] = useState(office.status);
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const office_id = office.id;
    const company_id = office.company_id;
    const { loading, error, fieldErrors, handleSubmit } = useForm(onUpdate);


    const handleFormSubmit = (e) => {
        e.preventDefault();
        const id = office_id;
        handleSubmit(UpdateOffice, { id, company_id, name, address1, address2, postalCode, state, city, country, status });
    };

    useEffect(() => {
        if (
            name !== office.name ||
            address1 !== office.address1 ||
            address2 !== office.address2 ||
            city !== office.city ||
            state !== office.state ||
            postalCode !== office.postal_code ||
            country !== office.country ||
            status !== office.status
        ) {
            setSubmitDisabled(false);
        } else {
            setSubmitDisabled(true);
        }
    }, [ name, address1, address2, city, state, postalCode, country, status]);

    return (
        <Popup size="large" withClose withOverlay onClose={onClose}>
            <form method="post" onSubmit={handleFormSubmit}>

                <FormHeader title={t("Edit")} description={t("Update your office details here.")}
                            icon={<EditLargeIcon/>}></FormHeader>

                <div className="row mb-5 mt-5 align-items-center">
                    <div className="col-xs-6">
                        <Switch title={t("Active")}>
                            <input type="checkbox" name="status" id="status" checked={status} onChange={e => {
                                setStatus(e.target.checked)
                            }}/>
                        </Switch>
                    </div>
                </div>

                <div className="row mb-5 mt-5">
                    <div className="col-xs-12">
                        <FormSection title={t("Office Name")} required>
                            <input type="text" name="name" id="name" maxLength="50" value={name}
                                   placeholder={t("Office Name")}
                                   onChange={e => setName(e.target.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Address 1")} required>
                            <input type="text" name="adddress1" id="adddress1" maxLength="50" value={address1}
                                   onChange={e => setAddress1(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Address 2 (Optional)")}>
                            <input type="text" name="address2" id="address2" maxLength="50" value={address2}
                                   onChange={e => setAddress2(e.target.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("City")} required>
                            <input type="text" name="city" id="city" maxLength="50" value={city}
                                   onChange={e => setCity(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Province")} required>
                            <StateSelect value={state} onChange={option => setState(option.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Postal Code")} required>
                            <input type="text" name="postalCode" id="postalCode" maxLength="50" value={postalCode}
                                   onChange={e => setPostalCode(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Country")} required>
                            <CountrySelect onlyCountry={'Canada'} value={country}
                                           onChange={option => setCountry(option.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="text-right">
                    <button className={`btn btn-primary btn-medium ${loading ? 'btn-loading' : ''}`} type="submit"
                            name="submit" disabled={submitDisabled}>
                        {loading ? <LoadingIcon/> : ''}
                        {t("Save")}
                    </button>
                </div>
                {error && <p className="color-error text-center mt-3">{error}</p>}
                {fieldErrors.map((error, index) => (
                    <p key={index} className="color-error text-center mt-3">{error.message}</p>
                ))}
            </form>
        </Popup>
    );
};

export default EditOffice;